import { render } from "./ClickAnimationEditor.vue?vue&type=template&id=2f01f966&scoped=true&ts=true"
import script from "./ClickAnimationEditor.vue?vue&type=script&lang=ts"
export * from "./ClickAnimationEditor.vue?vue&type=script&lang=ts"

import "./ClickAnimationEditor.vue?vue&type=style&index=0&id=2f01f966&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f01f966"]])

export default __exports__